export default __webpack_public_path__ + "static/media/steve_lying.5bd09af0.png";